package com.tovtalk.utils.logger

import co.touchlab.kermit.Logger as KermitLogger
import co.touchlab.kermit.Severity

/**
 * Logger Wrapper
 */
object Logger {
    private val logger = KermitLogger.withTag("TovTalk")
    
    fun d(message: String, tag: String? = null, throwable: Throwable? = null) {
        val taggedLogger = tag?.let { logger.withTag(it) } ?: logger
        taggedLogger.d(throwable) { message }
    }
    
    fun i(message: String, tag: String? = null, throwable: Throwable? = null) {
        val taggedLogger = tag?.let { logger.withTag(it) } ?: logger
        taggedLogger.i(throwable) { message }
    }
    
    fun w(message: String, tag: String? = null, throwable: Throwable? = null) {
        val taggedLogger = tag?.let { logger.withTag(it) } ?: logger
        taggedLogger.w(throwable) { message }
    }
    
    fun e(message: String, tag: String? = null, throwable: Throwable? = null) {
        val taggedLogger = tag?.let { logger.withTag(it) } ?: logger
        taggedLogger.e(throwable) { message }
    }
    
    fun v(message: String, tag: String? = null, throwable: Throwable? = null) {
        val taggedLogger = tag?.let { logger.withTag(it) } ?: logger
        taggedLogger.v(throwable) { message }
    }
}
